import React from "react";

/**
 * CoinStack — three crypto coins orbiting a center point.
 * BTC orange, ETH blue, USDC blue. Pure CSS rotation.
 *
 * The orbit container rotates; the inner coin counter-rotates so the letter
 * stays upright. Mobile: smaller diameter.
 */
const COINS = [
  { sym: "₿",   bg: "var(--l2-coin-btc)",  name: "BTC"  },
  { sym: "Ξ",   bg: "var(--l2-coin-eth)",  name: "ETH"  },
  { sym: "USDC", bg: "var(--l2-coin-usdc)", name: "USDC" },
];

const CoinStack = ({ size = 280 }) => {
  return (
    <div
      data-testid="coin-stack"
      className="relative"
      style={{
        width: `clamp(160px, ${size / 16}vw, ${size}px)`,
        height: `clamp(160px, ${size / 16}vw, ${size}px)`,
      }}
    >
      <div className="absolute inset-0 l2-orbit">
        {COINS.map((c, i) => {
          const angle = (i / COINS.length) * 360;
          return (
            <div
              key={c.name}
              className="absolute top-1/2 left-1/2"
              style={{
                transform: `translate(-50%, -50%) rotate(${angle}deg) translateY(-42%) rotate(-${angle}deg)`,
              }}
            >
              <div
                className="rounded-full flex items-center justify-center l2-display"
                style={{
                  width: "clamp(54px, 7vw, 84px)",
                  height: "clamp(54px, 7vw, 84px)",
                  background: c.bg,
                  color: "var(--l2-paper)",
                  fontSize: c.name === "USDC" ? "clamp(11px, 1.3vw, 15px)" : "clamp(24px, 3vw, 36px)",
                  boxShadow:
                    "0 12px 24px -6px rgba(31, 27, 23, 0.3), inset 2px 2px 6px rgba(255,255,255,0.25), inset -2px -2px 6px rgba(0,0,0,0.2)",
                }}
              >
                {c.sym}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CoinStack;
